import React, {useEffect, useState} from 'react';
import {
    IonIcon, IonRow, IonText,
} from "@ionic/react";
import {
    cashOutline, documentOutline,
    locationOutline, lockClosedOutline
} from "ionicons/icons";
import moment from "moment-timezone";
import {actionToGetAllJobAppliedMemberList} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import {callFunctionToDownload} from "../lib/downloadHelper";
import JobAppliedMemberDataModal from "./JobAppliedMemberDataModal";

export default function JobDetails({jobDetailsData}){
    const {userAuthDetail,setJobAppliedMemberDataList,jobAppliedMemberDataList} = useStore();
    const {userInfo} = userAuthDetail;
    const [isOpenAppliedModal,setIsOpenAppliedModal] = useState(false);
    const [jobAppliedMemberData,setJobAppliedMemberData] = useState(null);
    useEffect(() => {
        setJobAppliedMemberDataList([]);
        if(jobDetailsData?.applied_member_id_array  && jobDetailsData?.created_by === userInfo?.id){
            let jobAppliedMemberIdArray = [];
            try{
                jobAppliedMemberIdArray = JSON.parse(jobDetailsData?.applied_member_id_array);
            }catch (e){
                console.log('not valid')
            }
            actionToGetAllJobAppliedMemberList(jobAppliedMemberIdArray);
        }
    }, [jobDetailsData]);

    const handleToOpenAppliedMember = (userData)=>{
        setIsOpenAppliedModal(true);
        setJobAppliedMemberData(userData);
    }

    const closeAppliedMember = ()=>{
        setIsOpenAppliedModal(false);
        setJobAppliedMemberData(null);
    }

    return (
        <div className="job_detail_common_page" data-publisher-content="true">
            {/* Basic Job Info */}
            <div className="job-card">
                <div className={"d-flex ion-align-items-center job-card-header"}>
                    <div className="company-icon">
                        {(jobDetailsData?.image_url) ?
                            <img alt={"company"} src={jobDetailsData?.image_url}/>
                            :
                            <div className="name_initial">{jobDetailsData?.title?.substring(0,1).toUpperCase()}</div>
                        }
                    </div>
                    <div className={`approved_tag_section_tag ${jobDetailsData?.is_approved ? 'approved' : 'not_approved'}`}>
                        {jobDetailsData?.is_approved ? 'Approved' : 'Pending'}
                    </div>
                </div>
                <hr/>
                <div className="job-info">
                    <h3>{jobDetailsData.title}</h3>
                    <div className="company-rating">
                        {jobDetailsData.company}
                    </div>
                    <div className="job-meta">
                        <span><IonIcon icon={locationOutline}/> {jobDetailsData.location} &nbsp;|&nbsp;</span>
                        <span> <IonIcon icon={lockClosedOutline}/> {jobDetailsData.experience} Years</span>
                        <span>{jobDetailsData.salary_min && jobDetailsData.salary_max && (
                            <>
                                &nbsp;|&nbsp; <IonIcon icon={cashOutline}/>
                                {(jobDetailsData.salary_min / 100000)} - {(jobDetailsData.salary_max / 100000)} Lakh P.A
                            </>
                        )}</span>
                    </div>
                    <div className="tags-row">
                        <span className="job-tag">Department</span>
                        <span className="job-tag">{jobDetailsData?.department}</span>
                        <span className="job-tag">{jobDetailsData.apply_email}</span>
                        <div className="posted">
                            {
                                (() => {
                                    const daysLeft = moment(jobDetailsData.valid_date).startOf('day').diff(moment().startOf('day'), 'days');
                                    return daysLeft < 0
                                        ? 'Expired'
                                        : `${daysLeft} Day${daysLeft !== 1 ? 's' : ''} Left`;
                                })()
                            }
                        </div>
                    </div>

                </div>
            </div>
            {/* Job Description */}
            {(jobAppliedMemberDataList?.length) ? (
                <div className="job-description">
                    <IonText>
                        <h6>Applied Members</h6>
                    </IonText>
                    <div className="applied-members-list">
                        {jobAppliedMemberDataList.map((member, index) => (
                            <div key={index} className="applied-member-card">
                                <IonRow>
                                    <div className={"applied_member_detail"}>
                                        <p><strong>Name:</strong> {member.name}</p>
                                        <p><strong>Email:</strong> {member.email}</p>
                                    </div>
                                    <hr/>
                                    <div className={"applied_member_detail_cv_url_open"}>
                                        <div className={"applied_member_detail_cv_url"}>
                                            <IonIcon icon={documentOutline}/>{" "}
                                            <a onClick={()=>callFunctionToDownload(member.cv_url)}>
                                                Download Candidate CV
                                            </a>
                                        </div>
                                        <div onClick={()=>handleToOpenAppliedMember(member)} className="in_card_action_button_edit_del open">
                                            Open
                                        </div>
                                    </div>
                                </IonRow>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                ""
            )}

            <div className="job-description">
                <IonText><h6>Job description</h6></IonText>
                <p>{jobDetailsData?.description}</p>
            </div>
            <div className="job-key-responsiblities">
                <IonText><h6>Key Responsibilities:</h6></IonText>
                <p>{jobDetailsData?.responsiblities}</p>
            </div>
            <div className="job-key-responsiblities">
                <IonText><h6>Job Detail Pdf:</h6></IonText>
                <ul>
                    <li>
                        {jobDetailsData.pdf_url ? (
                            <>
                                <IonIcon icon={documentOutline}/>{" "}
                                <a onClick={()=>callFunctionToDownload(jobDetailsData.pdf_url)} rel="noopener noreferrer">
                                    Download PDF
                                </a>
                            </>
                        ) : (
                            "No attachment"
                        )}
                    </li>
                </ul>
            </div>
            <div className="job-requirement">
                <IonText><h6>Requirements:</h6></IonText>
                <p>{jobDetailsData?.requirement}</p>
            </div>
            {(isOpenAppliedModal) ?
                <JobAppliedMemberDataModal isOpen={isOpenAppliedModal} onClose={closeAppliedMember} memberData={jobAppliedMemberData} />
                :''}
        </div>
    )
}